const withLoading = (Component, LoadingComponent) => (props) => {
  const { isLoading, ...other } = props;

  if (isLoading) return <LoadingComponent {...other} />;

  return <Component {...other} />;
};

export default withLoading;
